import { useCallback, useEffect, useRef, useState } from "react";

export function useIsMounted() {
  const isMountedRef = useRef(true);
  const isMounted = useCallback(() => isMountedRef.current, []);

  useEffect(() => {
    return () => void (isMountedRef.current = false);
  }, []);

  return isMounted;
}

export const useSessionStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    const stored = localStorage.getItem(key);
    return stored !== null ? JSON.parse(stored) : defaultValue;
  })

  const setAndStoreValue = useCallback((newValue) => {
    setValue(newValue);
    if ([undefined, null, ''].includes(newValue)) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, JSON.stringify(newValue));
    }
  }, [key])

  return [value, setAndStoreValue];
}

export const useLocalStorage = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    const stored = localStorage.getItem(key);
    return stored !== null ? JSON.parse(stored) : defaultValue;
  })

  const setAndStoreValue = useCallback((newValue) => {
    setValue(newValue);
    if ([undefined, null, ''].includes(newValue)) {
      localStorage.removeItem(key);
    } else {
      localStorage.setItem(key, JSON.stringify(newValue));
    }
  }, [key])

  return [value, setAndStoreValue];
}